/**
 * Check if user stored in localStorage has any subResource with given codes.
 * @param {string[]} targetCodes - Array of subResourceCode strings to check for.
 * @param {string} storageKey - localStorage key where user data is stored (default: "userDetails").
 * @returns {boolean} - True if any subResourceCode matches, otherwise false.
 */
function hasUserSubResource(targetCodes, storageKey = "userDetails") {
  const storedData = localStorage.getItem(storageKey);
  if (!storedData) return false;

  try {
    const parsedData = JSON.parse(storedData);
    const roleResources = parsedData?.[0]?.resources || [];
    const allSubResources = roleResources.flatMap(resource => resource.subResources || []);
    return allSubResources.some(res => targetCodes.includes(res.subResourceCode));
  } catch (error) {
    console.error("Failed to parse user data from localStorage:", error);
    return false;
  }
}
export default hasUserSubResource;